export default __webpack_public_path__ + "static/media/download-google-play-badge-en.cbc57260.svg";